import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const DEPARTMENT_DELETE_RESOURCE = "department" as const;
export const DEPARTMENT_DELETE_API_PATH = `/v1/${DEPARTMENT_DELETE_RESOURCE}/{uuid}` as const;

export type DepartmentDeleteResponse =
  paths[typeof DEPARTMENT_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useDepartmentDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<DepartmentDeleteResponse, Error, { uuid: string; force?: boolean }>({
    mutationFn: async ({ uuid, force }) => {
      const response = await alphartisApiAxios.delete<DepartmentDeleteResponse>(
        `/v1/${DEPARTMENT_DELETE_RESOURCE}/${uuid}`,
        { params: { force } },
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [DEPARTMENT_DELETE_RESOURCE],
      });
    },
  });
};
